import {DAY_MS, iso, makeShareToken, EUROPE_COUNTRIES, MOCK_ICCID, MOCK_DOMAIN_ID, MOCK_ACTIVATION_CODE, MOCK_RESELLER_INFORMATION} from "./shared";

// "Unlimited" demo: installed, 18 of 30 validity days left, comfortably
// green - data itself has no cap, so the ring/usage panel report days left
// and today's full-speed quota (extendedDataPolicy) instead of a GB balance.
function dates() {
    return {
        activatedAt: iso(-12 * DAY_MS),
        expiresAt: iso(-12 * DAY_MS + 30 * DAY_MS),
        salesDate: iso(-12 * DAY_MS - 60 * 60 * 1000)
    };
}

function extendedDataPolicy() {
    return {
        type: "unlimited",
        resetType: "timeInterval",
        interval: "24h",
        fixedTime: "00:00",
        throttleSpeed: "240kb/s",
        totalHighSpeedVolume: {sizeValue: 2, sizeUnit: "GB"},
        remainingHighSpeedVolume: {sizeValue: 0.5, sizeUnit: "GB"},
        nextResetTime: iso(DAY_MS)
    };
}

export function getMockCustomerProfile() {
    const {activatedAt, expiresAt, salesDate} = dates();

    return {
        totalAvailableBalance: {sizeValue: 0, sizeUnit: "GB"},
        balances: [
            {
                price: {priceValue: 19.99, currencyCode: "USD"},
                salesDate,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                includedCountries: EUROPE_COUNTRIES,
                balance: {
                    name: "Europe Unlimited Pack",
                    activatedAt,
                    expiresAt,
                    activationMode: "NOW",
                    size: {sizeValue: 0, sizeUnit: "GB"},
                    availableBalance: {sizeValue: 0, sizeUnit: "GB"},
                    validitySize: 30, validityUnit: "days",
                    countrySet: "eur",
                    extendedDataPolicy: extendedDataPolicy()
                }
            }
        ],
        relatedEsims: [
            {
                uid: "esim-uid-002",
                active: true,
                state: "Installed",
                iccid: MOCK_ICCID,
                customerProfileDomainId: MOCK_DOMAIN_ID,
                activatedAt,
                lastSeen: iso(-15 * 60 * 1000),
                installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
                appleUniversalLink: "https://example.com/esim/apple-install",
                androidUniversalLink: "https://example.com/esim/android-install",
                activationCode: MOCK_ACTIVATION_CODE,
                imsi: ""
            }
        ],
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}

export function getMockEsimData() {
    const {activatedAt, expiresAt} = dates();

    return {
        esimProfile: {
            uid: "esim-uid-002",
            active: true,
            state: "Installed",
            iccid: MOCK_ICCID,
            customerProfileDomainId: MOCK_DOMAIN_ID,
            activatedAt,
            lastSeen: iso(-15 * 60 * 1000),
            installationUrl: `https://example.com/esim?token=${makeShareToken(MOCK_ICCID)}`,
            appleUniversalLink: "https://example.com/esim/apple-install",
            androidUniversalLink: "https://example.com/esim/android-install",
            activationCode: MOCK_ACTIVATION_CODE,
            imsi: ""
        },
        balances: [
            {
                name: "Europe Unlimited Pack",
                activatedAt,
                expiresAt,
                activationMode: "NOW",
                size: {sizeValue: 0, sizeUnit: "GB"},
                availableBalance: {sizeValue: 0, sizeUnit: "GB"},
                validitySize: 30, validityUnit: "days",
                countrySet: "eur",
                extendedDataPolicy: extendedDataPolicy()
            }
        ],
        totalAvailableBalance: {sizeValue: 0, sizeUnit: "GB"},
        customerProfileUrl: "https://example.com/customer/profile?token=mock-customer-token",
        resellerInformation: MOCK_RESELLER_INFORMATION
    };
}
